import * as React from "react";
const SvgVisible = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.756 5.75c-5.578 0-8.845 3.976-9.923 6.227 1.241 2.267 4.81 6.273 10.412 6.273 5.577 0 8.844-3.976 9.922-6.227-1.24-2.267-4.81-6.273-10.411-6.273ZM.328 12.334a.781.781 0 0 1-.078-.312.747.747 0 0 1 .06-.316C1.358 9.209 5.09 4.25 11.756 4.25c6.648 0 10.703 4.939 11.916 7.416a.754.754 0 0 1 .018.628c-1.048 2.496-4.78 7.456-11.446 7.456-6.648 0-10.702-4.939-11.916-7.416ZM8.75 12a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM12 7.25a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgVisible;
